/* Mini-storleksguiden. Lag inline i snippets/on-size-pop.liquid och renderades
   TVA ganger per produktsida, 9 041 byte styck. Flyttad hit 2026-10-09.

   De sju varden som kom fran Liquid, sex oversatta strangar och accentfargen,
   satts i window.__onSzpT av en rad inline och las i K hogst upp.

   Triggern [data-sizepop] ligger i klickbryggan sedan 2026-10-12 (rad 58).
   Fyra skript reagerar pa den: den har, snabbvyn och on-variant-change inne i
   sina dialoger (som stoppar bubblingen), och on-fbt, som faller ut kortet.
   Dialogerna och on-fbt:s kort finns forst nar deras moduler kort, efter den
   har. Ett omspelat klick pa en trigger ute pa sidan nar alltsa bara den har. */

  var K = window.__onSzpT || {};

  (function () {
    if (window.__onSzpInit) return;
    window.__onSzpInit = true;
    var T_SZ = (K.sz||"");
    var T_CLOSE = (K.close||"");
    var ACCENT = (K.accent||"");
    var T_CALC = { title: (K.ctitle||""), hint: (K.chint||""), result: (K.cresult||""), note: (K.cnote||"") };

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    /* Bor i snippeten on-size-calc (assets/on-sma.js). Las forst vid anrop, inte
       nar filen kors: on-cart-infra (LIVE, 2026-10-12) lagger in skripten dynamiskt,
       och da kors externa skript i laddningsordning, sa on-sma.js kan komma efter. */
    function maxNum(x) { return window.onSizeCalc.maxNum(x); }

    function ensureDialog() {
      var d = document.querySelector('dialog[data-szp-dialog]');
      if (d) {
        if (d.parentElement !== document.body) document.body.appendChild(d);
        return d;
      }
      d = document.createElement('dialog');
      d.className = 'on-szp';
      d.setAttribute('data-szp-dialog', '');
      d.setAttribute('aria-label', T_SZ);
      d.style.setProperty('--on-szp-accent', ACCENT);
      d.style.cssText += ';width:min(620px,94vw);max-width:94vw;max-height:88vh;padding:0;border:0;border-radius:14px;background:#fff;color:#111;overflow:hidden;box-sizing:border-box;';
      d.innerHTML =
        '<div class="on-szp__top"><span class="on-szp__head">' +
        '<span class="on-szp__label">' + esc(T_SZ) + '</span>' +
        '<strong class="on-szp__title" data-szp-title></strong></span>' +
        '<button type="button" class="on-szp__x" data-szp-close aria-label="' + esc(T_CLOSE) + '">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></div>' +
        '<div class="on-szp__body"><div class="on-szp__gender" data-szp-gender hidden></div><div class="on-szp__calc" data-szp-calc hidden></div><table class="on-szp__table" data-szp-table></table></div>';
      document.body.appendChild(d);
      return d;
    }

    function buildCalc(calcEl, headers, dataRows, desired) {
      var labelRe = /^(storlek|size|str|eu|us|uk|größe|størrelse|koko|maat|taille|taglia|talla|rozmiar|tamanho)$/i;
      var measure = [];
      headers.forEach(function (h, i) {
        var hn = ('' + (h || '')).replace(/\(.*?\)/g, '').trim();
        if (i === 0 || labelRe.test(hn)) return;
        measure.push({ idx: i, label: hn });
      });
      if (measure.length < 1) { calcEl.hidden = true; return; }
      var rows = dataRows.map(function (cells) {
        var vals = {};
        measure.forEach(function (m) { vals[m.idx] = maxNum(cells[m.idx]); });
        return { size: (cells[0] || '').trim(), vals: vals };
      });
      var sel = [];
      (desired || []).forEach(function (name) {
        if (sel.length >= 2) return;
        var m = measure.filter(function (x) { return x.label.toLowerCase() === name; })[0];
        if (m && sel.indexOf(m) === -1) sel.push(m);
      });
      if (!sel.length) sel = measure.slice(0, 2);
      sel = sel.slice(0, 2);

      calcEl.innerHTML =
        '<div class="on-szp__calc-title">' + esc(T_CALC.title) + '</div>' +
        '<div class="on-szp__calc-hint">' + esc(T_CALC.hint) + '</div>' +
        '<div class="on-szp__calc-fields" data-szp-fields>' +
        sel.map(function (m) { return '<label class="on-szp__calc-field"><span>' + esc(m.label) + ' (cm)</span><input type="number" inputmode="decimal" min="0" step="0.1" data-cidx="' + m.idx + '" placeholder="cm"></label>'; }).join('') +
        '</div>' +
        '<div class="on-szp__calc-res" data-szp-res hidden><span>' + esc(T_CALC.result) + '</span> <strong data-szp-val></strong></div>' +
        '<div class="on-szp__calc-note">' + esc(T_CALC.note) + '</div>';
      calcEl.hidden = false;

      function compute() {
        /* Popupen märker sina fält "cm" och ber aldrig om tum, och triggern
           skickar ingen stretch-data. Därför false på båda - det bevarar
           exakt dagens beteende, inklusive att ett mått över största
           storleken faller tillbaka på den största raden. */
        var matt = sel.map(function (m) {
          var inp = calcEl.querySelector('input[data-cidx="' + m.idx + '"]');
          return { idx: m.idx, varde: inp ? inp.value : '' };
        });
        var ut = window.onSizeCalc.rekommendera(rows, matt, {
          tum_till_cm: false,
          anvand_stretch_tak: false
        });
        var res = calcEl.querySelector('[data-szp-res]'), val = calcEl.querySelector('[data-szp-val]');
        if (ut.index < 0) { if (res) res.hidden = true; return; }
        if (val) val.textContent = rows[ut.index].size;
        if (res) res.hidden = false;
      }
      var fields = calcEl.querySelector('[data-szp-fields]');
      if (fields) fields.addEventListener('input', compute);
    }

    // Öppna guiden från en valfri [data-sizepop]-knapp. Exponeras globalt så att
    // popupar som stoppar click-bubbling (t.ex. byt-variant-dialogen i varukorgen)
    // kan öppna guiden DIREKT utan att förlita sig på document-delegationen.
    function parseRows(str) {
      return (str || '').split(';;').map(function (r) { return r.trim(); }).filter(Boolean)
        .map(function (r) { return r.split('|').map(function (c) { return c.trim(); }); });
    }

    // Renderar EN tabell (+ kalkylator) i dialogen från ett dataset { title, rows, calc, g }.
    function renderChart(d, ds) {
      var titleEl = d.querySelector('[data-szp-title]');
      var tableEl = d.querySelector('[data-szp-table]');
      var calcEl = d.querySelector('[data-szp-calc]');
      if (titleEl) titleEl.textContent = ds.title || '';
      if (tableEl) {
        tableEl.innerHTML = ds.rows.map(function (cells, i) {
          return '<tr>' + cells.map(function (c) { return i === 0 ? '<th>' + esc(c) + '</th>' : '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
        }).join('');
      }
      if (calcEl) {
        var desired = (ds.calc || '').split('|').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        if (ds.rows.length > 1) buildCalc(calcEl, ds.rows[0], ds.rows.slice(1), desired);
        else { calcEl.hidden = true; calcEl.innerHTML = ''; }
      }
    }

    // Dam/Herr-växlare (om produkten har en köns-motpart med egen tabell). Dam vänster, Herr höger.
    function buildGenderToggle(d, cur, alt, lw, lm) {
      var genderEl = d.querySelector('[data-szp-gender]');
      if (!genderEl) return;
      if (!alt) { genderEl.hidden = true; genderEl.innerHTML = ''; return; }
      var women = cur.g === 'women' ? cur : alt;
      var men = cur.g === 'men' ? cur : alt;
      genderEl.innerHTML = '';
      function mk(label, ds, active) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'on-szp__gbtn' + (active ? ' is-active' : '');
        b.textContent = label;
        b.addEventListener('click', function () {
          renderChart(d, ds);
          Array.prototype.forEach.call(genderEl.querySelectorAll('.on-szp__gbtn'), function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
        return b;
      }
      genderEl.appendChild(mk(lw, women, cur.g === 'women'));
      genderEl.appendChild(mk(lm, men, cur.g === 'men'));
      genderEl.hidden = false;
    }

    function openFromButton(btn) {
      if (!btn) return;
      var d = ensureDialog();
      var cur = {
        title: btn.getAttribute('data-title') || '',
        rows: parseRows(btn.getAttribute('data-rows')),
        calc: btn.getAttribute('data-calc') || '',
        g: btn.getAttribute('data-g') || 'women'
      };
      var alt = null;
      if (btn.getAttribute('data-rows-alt')) {
        alt = {
          title: btn.getAttribute('data-title-alt') || '',
          rows: parseRows(btn.getAttribute('data-rows-alt')),
          calc: btn.getAttribute('data-calc-alt') || '',
          g: btn.getAttribute('data-alt-g') || 'men'
        };
      }
      renderChart(d, cur);
      buildGenderToggle(d, cur, alt, btn.getAttribute('data-lw') || 'Dam', btn.getAttribute('data-lm') || 'Herr');
      if (d.showModal) { try { d.showModal(); } catch (err) { d.setAttribute('open', ''); } } else { d.setAttribute('open', ''); }
    }
    window.__onSzpOpen = openFromButton;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sizepop]');
      if (btn) {
        e.preventDefault();
        openFromButton(btn);
        return;
      }
      var closer = e.target.closest('[data-szp-close]');
      if (closer) {
        var d2 = closer.closest('[data-szp-dialog]');
        if (d2) { if (d2.close) d2.close(); else d2.removeAttribute('open'); }
        return;
      }
      var open = document.querySelector('dialog[data-szp-dialog][open]');
      if (open && e.target === open) { if (open.close) open.close(); else open.removeAttribute('open'); }
    });
  })();
